var _defs, _polygon, _polygon2, _ellipse, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotchflap01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-77,.cls-76{fill:#fff;stroke:#010101;stroke-miterlimit:10;}.cls-77{stroke-width:3.05px;}.cls-76{stroke-width:1.04px;stroke-dasharray:3.12;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "352.04 202.02 352.04 280.1 214.06 317.98 70.96 280.1 70.96 202.02 352.04 202.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "348.83 205.46 348.83 277.13 214.03 314.74 74.17 277.04 74.17 205.46 348.83 205.46"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.57,
    cy: 285.03,
    rx: 16.66,
    ry: 16.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 212.85,
    y: 263.09,
    width: 3.44,
    height: 44.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotchflap01);
export default __webpack_public_path__ + "static/media/NOTCH FLAP-01.98f9f355460acb110829b874402af741.svg";
export { ForwardRef as ReactComponent };